import React from 'react';
import styles from './A23PlayerDetails.module.css';
import { RUPEE_SYMBOL } from '@/Poker/data/Constants';
import { parseDecimalValuesOfNumber } from '../../../../Common/utils/GameUtils';
import { GiBulletBill, GiSilverBullet } from "react-icons/gi";
import { FaSkullCrossbones } from "react-icons/fa";

const A23PlayerDetails = ({
    displayName,
    userName,
    atTableAmount,
    winningAmount,
    isFolded,
    isSeatedOut,
    isInactive,
    gameDefinition,
    bountyAmount
}) => {

    const { bountyTourney, isTourneyGame } = gameDefinition;

    return (
        <div className={`${styles.playerDetails} ${isFolded || isSeatedOut || isInactive ? styles.folded : ''}`}>
            <div className={`${styles.playerDetail} ${styles.playerName}`}>
                {displayName || userName}
            </div>
            <div className={`${styles.playerDetail} ${styles.playerBalance}`}>
                {RUPEE_SYMBOL}{parseDecimalValuesOfNumber(atTableAmount, 2, true, true)}
            </div>
            <div className={styles.playerColorTag}>
            </div>
            {
                bountyTourney && bountyAmount ?
                    <div className={`${styles.bountyAmount}`}>
                        <FaSkullCrossbones color={'var(--color-primary)'} />
                        {bountyAmount}
                    </div>
                    : null
            }

        </div>
    );
};

export default A23PlayerDetails; 